import {useState} from 'react'
import header from './Header.module.scss'
import logo from '../../image/Header/logo.png'
import log from '../../image/Header/ll.png'
import ButtonBox from '../ButtonBox/ButtonBox'
import yandex from '../../image/Header/orig_1.png'

const Header = ({isOpen}) => {

    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 10){
            setVisible(true)
        } 
        else if (scrolled <= 10){
            setVisible(false)
        }
    }

    window.addEventListener('scroll', toggleVisible);

    return (
        <header className={`${header.header} ${visible && header.header_scroll}`}>
        <div className={header.box}>
                <div className={header.info}>
                    <div className={header.box_logo}>
                        <a className={header.logo_link} href='initial'>
                            <img className={header.logo} src={logo} alt = 'логотип'/>
                            <img className={header.logo_min} src={log} alt = 'логотип'/>
                        </a>
                        <div className={header.contacts}>
                            <img className={header.yandex} src={yandex} alt = 'логотип'/>
                            <div className={header.box_social}>
                                <ButtonBox/>
                            </div>
                            <div className={header.box_phone}>
                                <a className={header.phone}  href="tel:+79998483760" target='_blank' rel='noopener noreferrer'>+7 999 <span>848-37-60</span></a>
                                <a className={header.phone}  href="tel:+79936105591" target='_blank' rel='noopener noreferrer'>+7 993 <span>610-55-91</span></a>
                            </div>
                            <a className={header.phone_mobile}  href="tel:+79998483760" target='_blank' rel='noopener noreferrer'>ПОЗВОНИТЬ</a>
                        </div>
                        <button className={header.button} type='button' onClick={isOpen} aria-label='Открыть меню'/>
                    </div>
                    <nav className={header.nav}>
                        <a className={header.link} href='#Services'>Услуги</a>
                        <div className={header.line}></div>
                        <a className={header.link} href='#Advantages'>Преимущества</a>
                        <div className={header.line}></div>
                        <a className={header.link} href='#Portfolio'>Портфолио</a>
                        <div className={header.line}></div>
                        <a className={header.link} href='#Scheme'>Схема работы</a>
                        <div className={header.line}></div>
                        <a className={header.link} href='#Reviews'>Отзывы</a>
                    </nav>
                </div>
        </div>
    </header>    
    );
};

export default Header